
define('modules/application/wizard/classes/kits/energyManagementKits',["app",

// Libs
"backbone",

//Classes
"../kits"],

function(app, Backbone, kits) {

  var kitModel = kits.KitModel.extend({

    initialize                        : function() {
      this.fetchProducts();
      this.fetchComponentsPackages();
      window.BticinoS4B.eventAggregator.bind("connectToKit", this.connectItems, this);

      var packages       = this.get("specialVars").packages,
          packagesLength = packages.length,
          maxZoneNumber  = 0,
          j              = 0;

      for(j=0; j<packagesLength; j++)
      {
        if (packages[j].specialVars && packages[j].specialVars.maxZoneNumber)
        {
          maxZoneNumber = packages[j].specialVars.maxZoneNumber;
          break;
        }
      }

      this.set("maxZoneNumber", maxZoneNumber);
    },
    // insertThisKit                     : function(kitCode) {
    //   var value         = this.findValueFromProductCode(kitCode);
    //   var finalPackage, dataToReturn = {};

    //   if (value)
    //   {
    //     dataToReturn.packages = [finalPackage];
    //     this.kitsFetchedEventHandler(dataToReturn);
    //     this.confirmSelectedKit();
    //   }
    // },

    addKit                : function(_silent) {
      var added = this.get("added");
      var silent= false;

      if (_silent)
        silent = _silent;

      if (!added)
      {
        var kitPackages = this.get("specialVars") ? this.get("specialVars").packages : [];

        var zoneNumberChangedEventHandler  =  function(newZoneNumber) {
          this.addToZone = newZoneNumber;
        };

        var requestRefresh                 = function() {
          this.trigger("render:requested");
        };

        for(var i=0, packagesLength = kitPackages.length; i<packagesLength; i++)
        {
          if (!silent || kitPackages[i].name==="powerSupply" || kitPackages[i].name==="keyCover" || kitPackages[i].name==="configurators")
          {
            kitPackages[i].kitsEventAggregator = _.extend({}, Backbone.Events);
            kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", zoneNumberChangedEventHandler, kitPackages[i]);
            kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", requestRefresh, this);
            window.BticinoS4B.eventAggregator.trigger(kitPackages[i].name+":addedFromKit", kitPackages[i]);
          }
        }

        this.set("added", true);
        window.BticinoS4B.eventAggregator.trigger("kit:added");
        this.trigger("render:requested");
      }
      else
        this.removeCurrentKit();

      this.trigger("render:requested");
      this.trigger("updateViews");
    },

    isPossibleToAdd           : function() {
      return true;
    }
  });

  var energyManagementKits = _.extend({}, kits, {

    Model: kits.Model.extend({
      defaults: _.extend({
        wizardChoiceId : 849,
        dictionary        : [
            {
              productCode            : "MHKIT1013",
              packageClassId         : "22100"
            },
            {
              productCode            : "MHKIT4013",
              packageClassId         : "22101"
            }
          ]
        }, kits.Model.defaults),
        // addConstructor                    : function() {
        //   this.kitModel = kitModel;
        // },
        initialize                : function() {
          kits.Model.prototype.initialize.apply(this);
          this.addConstructor();
          window.BticinoS4B.eventAggregator.bind("connectToKit", this.connectItems, this);
        },

        isPossibleToAdd : function() {
          return true;
        }
        // insertThisKit                     : function(kitCode) {
        //   var value         = this.findValueFromProductCode(kitCode);
        //   var finalPackage, dataToReturn = {};

        //   if (value)
        //   {
        //     dataToReturn.packages = [finalPackage];
        //     this.kitsFetchedEventHandler(dataToReturn);
        //     this.confirmSelectedKit();
        //   }
        // }
      })
    });

  // Required, return the module for AMD compliance
  return energyManagementKits;
});